import React, { FC } from 'react'

import * as SC from './styled'

export type AccessibleProps = {
  id?: string
  text?: string
}

const Burger: FC<AccessibleProps> = ({ id, text = null }) => {
  if (!text) {
    return null
  }

  return <SC.Text id={id}>{text}</SC.Text>
}

export default Burger
